































import { Component, Prop } from "vue-property-decorator";

import { DialogSection, DialogForm, FormText } from "sitewhere-ide-components";
import { VFlex } from "vuetify/lib";

import { IDefaultMqttParameterExtractorConfiguration } from "sitewhere-configuration-model";

import { required } from "vuelidate/lib/validators";

@Component({
  components: { VFlex, DialogSection, DialogForm, FormText },
  validations: {
    commandTopicExpression: {
      required
    },
    systemTopicExpression: {
      required
    }
  }
})
export default class DefaultMqttParameterExtractorFields extends DialogSection {
  @Prop() readonly tenantId!: string;

  commandTopicExpression: string | null = null;
  systemTopicExpression: string | null = null;

  /** Reset section content */
  reset(): void {
    this.commandTopicExpression = null;
    this.systemTopicExpression = null;
    this.$v.$reset();
  }

  /** Perform validation */
  validate(): boolean {
    this.$v.$touch();
    return !this.$v.$invalid;
  }

  /** Load form data from an object */
  load(input: IDefaultMqttParameterExtractorConfiguration): void {
    this.commandTopicExpression =
      input.commandTopicExpression || "SiteWhere/${tenant}/command/${device}";
    this.systemTopicExpression =
      input.systemTopicExpression || "SiteWhere/${tenant}/system/${device}";
  }

  /** Save form data to an object */
  save(): IDefaultMqttParameterExtractorConfiguration {
    return {
      commandTopicExpression: this.commandTopicExpression || "",
      systemTopicExpression: this.systemTopicExpression || ""
    };
  }
}
